import styled from 'styled-components';

export const TooltipPrimitive = styled.div`
  z-index: 90001;
`;

export const TOOLTIP_COLOR = 'var(--color-tooltip-bg)';

export const TooltipDiv = styled(TooltipPrimitive)<{ truncate?: boolean }>`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: ${TOOLTIP_COLOR};

  /* Shadow/Shadow__S */
  box-shadow: var(--shadow-sm);

  word-wrap: break-word;
  overflow-wrap: break-word;

  color: var(--color-tooltip-text);

  /* Body/Medium */
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */

  max-width: 400px;

  ${({ truncate }) =>
    truncate &&
    `
      max-width: 420px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;

export const AltTooltipDiv = styled(TooltipPrimitive)`
  background: var(--color-bg-primary);
  border-radius: 4px;
  box-shadow: var(--shadow-md);
  box-sizing: content-box; /* do not set this to border-box or it will break the overflow handling */
  color: var(--color-text-secondary);
  padding: 4px 8px;
  max-width: 800px;

  html[data-theme='dark'] & {
    border: 1px solid var(--color-border-primary);
  }
`;

export const UnstyledTooltipDiv = styled(TooltipPrimitive)``;
